import GenerateForm from "./GenerateFormApi";

export default {
  GenerateForm
}